export default "__VITE_ASSET__BnpAke4L__"